if($('.module--banner-image-links a[data-thumbnail]').length) {
  
  $( '.module--banner-image-links' ).each(function() {
    var outerElement = $(this);

      outerElement.find('a[data-thumbnail]').each(function() {
      outerElement.find('.module--banner-image-links__image').append('<img data-identifier="' + $(this).data('identifier') + '" src="' + $(this).data('thumbnail') + '" alt="' + $(this).data('title') + '" title="' + $(this).data('title') + '" />');
    });
  });

  if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    $('.module--banner-image-links a[data-thumbnail]').hover(function() {
      $(this).closest('section.module--banner-image-links').find('.module--banner-image-links__image img').css('opacity', 0);
      $(this).closest('section.module--banner-image-links').find('.module--banner-image-links__image img[data-identifier="'+$(this).data('identifier')+'"]').css('opacity', 1);
    });
  }
}
